import styled, { css } from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';
import { TBoxType } from '.';
import { Label } from 'components';

interface Props {
    checked: boolean;
    boxType?: TBoxType;
}

export const CheckBoxWrapper = styled.div<Props>`
    position: relative;
    width: 100%;
    height: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    label {
        pointer-events: none;
    }

    ${props => {
        if (props.boxType === 'TAG') {
            return css`
                height: 44px;
                border-radius: 22px;
                ${props.checked ?
                    css`background: ${palette('blue_900')};
                        ${TagCheckLabel}{
                            color: ${palette('gray_opacity_50')}
                        }
                        ` :
                    css`
                        background: ${palette('gray_opacity_100')};
                        `}
                `
        } else if (props.boxType === 'CAPTION') {
            return css`
                    height: 60px;
                    border-radius: 8px;
                    border: 1px solid ${ifProp('checked', palette('blue_900'), palette('gray_opacity_200'))};
                    padding: 8px 20px;
                    justify-content: flex-start;

                    ${props.checked ?
                    css`${LabelCaption},
                        ${LabelTitle} {
                            color: ${palette('blue_900')};
                        }     
                        ${CaptionCheckDimd}{
                            background-color: ${palette('blue_opacity_100')}
                        }`: null}
                        `;
        } else if (props.boxType === 'RADIO') {
            return css`width: 20px;
                        ${RadioCheckIcon}{
                            ${props.checked ? css`border: 6.25px solid ${palette('blue_900')};` : null}
                        }`;
        } else {
            return css`
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid ${ifProp('checked', palette('blue_900'), palette('gray_opacity_200'))};
                    ${DefaultWrapper} {
                        display: flex;
                        align-items: center;
                    }
                    ${LabelWrapper} {
                        flex-direction: row;
                    }

                    ${props.checked ?
                    css`background-color: ${palette('blue_opacity_100')};
                            ${LabelTitle} {color: ${palette('blue_900')};}` : null}
                    `;
        }
    }
    }
`;

export const TagCheckLabel = styled.label`
    ${theme('fontStyle.body2')}
    color: ${palette('gray_opacity_600')}
`;

export const DefaultWrapper = styled.div`
`;

export const DefaultIconWrapper = styled.div`
    margin-right: 5px;
`;

export const RadioCheckIcon = styled.div`
    border: 1.5px solid ${palette('gray_opacity_300')};
    border-radius: 10px;
    width: 20px;
    height: 20px;
`;

export const IconWrapper = styled.div`
    margin-right: 12px;
`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LabelTitle = styled(Label)`
    color: ${palette('gray_opacity_600')};
`;

export const LabelCaption = styled(Label)`
    margin-top: 4px;
    color: ${palette('gray_opacity_400')};
`;

export const CaptionCheckDimd = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: ${palette('transparent')};
`;

export const CheckBox = styled.input`
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
`;